module.exports = __webpack_public_path__ + "img/bingo_ball-76.557e6d2f.png";